import {Directive, ElementRef, Renderer2, Input, AfterViewInit} from '@angular/core';

@Directive({
  selector: 'input[appNumericKeyboard]',
})
export class NumericKeyboardDirective implements AfterViewInit {

  @Input()
  appNumericKeyboard = false;

  constructor(public renderer: Renderer2, public hostElement: ElementRef){}

  ngAfterViewInit(): void {
    if (this.appNumericKeyboard) {
      this.renderer.setAttribute(this.hostElement.nativeElement, 'inputmode', 'numeric');
    }
  }
}
